import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";

import { errorToast, successToast } from "../../../utils/toasts";
import { type ProductPropertyUpdateSchema } from "../../../zodios/apiDefinitions/api/products";
import { invalidateProductQueries } from "../../perf_reports/api/product/invalidateProductQueries";

export function useBulkUpdateProductProperties() {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["advertising"]);
  return useMutation({
    mutationFn: async (vars: ProductPropertyUpdateSchema) => {
      await apiClient.bulkUpdateProductProperties(vars);
    },
    onSuccess: () => {
      successToast({ message: t(($) => $.advertising["Products Successfully Updated"]) });
      invalidateProductQueries(queryClient);
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.advertising["Failed to Update Products"]), error });
    },
  });
}
